import type { SongSpec } from "../../engine/audio/AudioEngine";

/**
 * Two-voice chiptunes. Each track is a list of steps: a note name starts a
 * note, "." holds the previous one, "-" is a rest.
 */
export const SONGS: Record<string, SongSpec> = {
  field: {
    tracks: [
      {
        tempo: 124,
        type: "square",
        gain: 0.075,
        notes: [
          "G4", ".", "C5", ".", "E5", ".", "D5", ".", "C5", ".", "E5", ".", "G5", ".", ".", ".",
          "F5", ".", "E5", ".", "D5", ".", "C5", ".", "D5", ".", "E5", ".", "C5", ".", ".", ".",
        ],
      },
      {
        tempo: 124,
        type: "triangle",
        gain: 0.09,
        notes: [
          "C3", ".", ".", ".", "G3", ".", ".", ".", "A2", ".", ".", ".", "E3", ".", ".", ".",
          "F2", ".", ".", ".", "C3", ".", ".", ".", "G2", ".", ".", ".", "G2", ".", ".", ".",
        ],
      },
    ],
  },

  town: {
    tracks: [
      {
        tempo: 100,
        type: "square",
        gain: 0.07,
        notes: [
          "E5", ".", "G5", ".", "A5", ".", ".", ".", "G5", ".", "E5", ".", "D5", ".", ".", ".",
          "C5", ".", "E5", ".", "G5", ".", ".", ".", "A5", ".", "G5", ".", "E5", ".", ".", ".",
        ],
      },
      {
        tempo: 100,
        type: "triangle",
        gain: 0.085,
        notes: [
          "C3", ".", ".", ".", "F3", ".", ".", ".", "G3", ".", ".", ".", "C3", ".", ".", ".",
          "A2", ".", ".", ".", "F2", ".", ".", ".", "G2", ".", ".", ".", "C3", ".", ".", ".",
        ],
      },
    ],
  },

  cave: {
    tracks: [
      {
        tempo: 82,
        type: "triangle",
        gain: 0.08,
        notes: [
          "A4", ".", ".", ".", "C5", ".", ".", ".", "B4", ".", ".", ".", "E4", ".", ".", ".",
          "F4", ".", ".", ".", "E4", ".", ".", ".", "D4", ".", ".", ".", "A4", ".", ".", ".",
        ],
      },
      {
        tempo: 82,
        type: "sawtooth",
        gain: 0.04,
        notes: [
          "A2", ".", ".", ".", ".", ".", ".", ".", "F2", ".", ".", ".", ".", ".", ".", ".",
          "G2", ".", ".", ".", ".", ".", ".", ".", "E2", ".", ".", ".", ".", ".", ".", ".",
        ],
      },
    ],
  },

  battle: {
    tracks: [
      {
        tempo: 168,
        type: "square",
        gain: 0.07,
        notes: [
          "E5", "E5", "-", "E5", "-", "C5", "E5", "-", "G5", "-", "-", "-", "G4", "-", "-", "-",
          "C5", "-", "-", "G4", "-", "-", "E4", "-", "A4", "-", "B4", "-", "Bb4", "A4", "-", "-",
        ],
      },
      {
        tempo: 168,
        type: "triangle",
        gain: 0.1,
        notes: [
          "E2", "-", "E2", "-", "E2", "-", "E2", "-", "C2", "-", "C2", "-", "G2", "-", "G2", "-",
          "C2", "-", "C2", "-", "G2", "-", "G2", "-", "A2", "-", "A2", "-", "E2", "-", "E2", "-",
        ],
      },
    ],
  },
};
